import { useSelector } from "react-redux";
import { IonItem, IonItemDivider, IonLabel, IonText } from "@ionic/react";
import { selectMessages } from "../../../store/locationShow/selectors/selectMessages";
import { MessageItem } from "../../../components/Message/MessageItem";
export const HistorySection: React.FC = () => {
  const messages = useSelector(selectMessages);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Bitácora</IonText>
      </h2>
      <section className="ion-padding-horizontal">
        {Object.entries(messages).length === 0 && (
          <IonItem lines="none">
            <IonLabel>
              <IonText color="medium">No se ha encontrado actividad</IonText>
            </IonLabel>
          </IonItem>
        )}
        {Object.entries(messages).map(([key, value]: any) => (
          <article key={key}>
            <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

            {value.map((messageItem: any, index: number) => (
              <MessageItem
                key={index}
                message={messageItem}
                routerLink={`/app/rrhh/acuerdos/${messageItem.document?.id}`}
              ></MessageItem>
            ))}
          </article>
        ))}
      </section>
    </>
  );
};
